import { Link } from 'react-router-dom'

import { styled } from 'styled-system/jsx'

const HeaderRoot = styled('header', {
  base: {
    width: '100%',
    paddingX: '24px',
    paddingY: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    backgroundColor: 'transparent',
  },
})

const HeaderLeft = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
  },
})

const HeaderRight = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
})

const Wordmark = styled(Link, {
  base: {
    fontFamily: 'display',
    fontSize: '22px',
    fontWeight: '800',
    letterSpacing: '-0.5px',
    color: 'quickpass.primary',
    textDecoration: 'none',
    cursor: 'pointer',
  },
})

const NavList = styled('nav', {
  base: {
    display: { base: 'none', lg: 'flex' },
    alignItems: 'center',
    gap: '20px',
  },
})

const NavLink = styled(Link, {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    fontWeight: '500',
    color: 'quickpass.inkSoft',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'color {durations.fast} {easings.appleStandard}',
    _hover: {
      color: 'quickpass.primary',
    },
  },
  variants: {
    isActive: {
      true: {
        color: 'quickpass.primary',
        fontWeight: '700',
      },
    },
  },
})

const NavLinkBadge = styled('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '6px',
    minWidth: '18px',
    height: '18px',
    paddingX: '5px',
    borderRadius: 'pill',
    backgroundColor: 'quickpass.primary',
    color: '#FFFFFF',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    lineHeight: '1',
  },
})

const ModeSwitchButton = styled('button', {
  base: {
    display: { base: 'none', lg: 'inline-flex' },
    alignItems: 'center',
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.primary',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'opacity {durations.fast} {easings.appleStandard}',
    _hover: {
      opacity: '0.7',
    },
  },
})

const DesktopAvatarSlot = styled('span', {
  base: {
    display: { base: 'none', lg: 'inline-flex' },
    alignItems: 'center',
  },
})

const MenuButton = styled('button', {
  base: {
    display: { base: 'inline-flex', lg: 'none' },
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    borderRadius: 'pill',
    border: 'none',
    backgroundColor: 'transparent',
    color: 'quickpass.inkSoft',
    fontSize: '18px',
    cursor: 'pointer',
    transition:
      'background-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}',
    _hover: {
      backgroundColor: 'quickpass.surfaceCool',
      color: 'quickpass.primary',
    },
  },
})

const SignOutButton = styled('button', {
  base: {
    display: { base: 'none', lg: 'inline-flex' },
    alignItems: 'center',
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    backgroundColor: 'transparent',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'pill',
    paddingX: '14px',
    paddingY: '6px',
    cursor: 'pointer',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.warmth',
      color: 'quickpass.warmth',
    },
  },
})

export {
  HeaderRoot,
  HeaderLeft,
  HeaderRight,
  Wordmark,
  NavList,
  NavLink,
  NavLinkBadge,
  ModeSwitchButton,
  DesktopAvatarSlot,
  MenuButton,
  SignOutButton,
}
